(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockAntragstellerDaten', {
            require: {
                form: '^form'
            },
            bindings: {
                onChangeAdresse: '&abadOnChangeAdresse',
                options: '<abadOptions'
            },
            templateUrl: 'bloecke/antragsteller/blockAntragstellerDaten.html',
            controller: BlockAntragstellerDatenController,
            controllerAs: 'antragstellerDatenVm'
        });

    BlockAntragstellerDatenController.$inject = [
        '$q',
        'lodash',
        'moment',
        'AppConfig',
        'AngebotModel',
        'BasisAngebotService',
        'MiscUtilsService',
        'AdresseUtilsService',
        'FormatUtilsService',
        'AngebotUtilsService',
        'SchluesselWerteUtilsService'
    ];
    function BlockAntragstellerDatenController($q, _, moment, AppConfig, AngebotModel, BasisAngebotService, MiscUtilsService, AdresseUtilsService, FormatUtilsService, AngebotUtilsService, SchluesselWerteUtilsService) {
        var vm = this,
            momentYearEndObj = {
                date: 31,
                month: 11
            };

        vm.$onInit = onInit;

        vm.getAdresseErrorObject = getAdresseErrorObject;
        vm.isTelefonnummerValide = isTelefonnummerValide;
        vm.setAdresseAntragsteller = setAdresseAntragsteller;
        vm.onChangeAnrede = onChangeAnrede;
        vm.onChangeFirmenname = onChangeFirmenname;

        function onInit() {
            activate();
        }

        function activate() {
            vm.options = vm.options || {};
            vm.angebotModel = AngebotModel.get();

            vm.isPrivatPerson = BasisAngebotService.isPrivatPerson(vm.angebotModel.angebot);
            vm.model = {};

            vm.model.anrede = _.get(vm.angebotModel.angebot, 'antragsteller.anrede');
            if (!BasisAngebotService.isPrivatPerson(vm.angebotModel.angebot)) {
                vm.title = 'Wie lauten Ihre Firmendaten?';
                MiscUtilsService.setDefaultValueIfEmpty(vm.model, 'anrede', _.find(SchluesselWerteUtilsService.getSchluesselwert('anreden'), { wert: '3' }));
                _.set(vm.angebotModel.angebot, 'antragsteller.anrede', vm.model.anrede);
            } else {
                vm.title = 'Wie lauten Ihre persönlichen Daten?';
                vm.filteredAnreden = MiscUtilsService.mergeUniq(MiscUtilsService.filterArray(SchluesselWerteUtilsService.getSchluesselwert('anreden'), ['Herr', 'Frau', 'Divers'], 'bezeichnung', true), _.get(vm.angebotModel.angebot, 'antragsteller.anrede'), 'wert');
            }

            vm.antragstellerAenderbarMap = AngebotUtilsService.getAntragstellerDatenAenderbarMap(vm.angebotModel.angebot);
            vm.regexTelephone = FormatUtilsService.regexTelephone;
            vm.isAngebotAenderbar = BasisAngebotService.isAngebotAenderbar(vm.angebotModel.angebot, 'ANTRAG');
            vm.maxAntragstellerGeburtsdatum = BasisAngebotService.getMaxAntragstellerGeburtsdatum(vm.angebotModel.angebot);

            vm.disableAdresseSearchStrasse = _.isNil(vm.options.disableAdresseSearchStrasse) ? true : vm.options.disableAdresseSearchStrasse;
            vm.disableAdresseSearchPostleitzahl = _.isNil(vm.options.disableAdresseSearchPostleitzahl) ? true : vm.options.disableAdresseSearchPostleitzahl;
            vm.cssClass = vm.options.cssClass || '';

            AdresseUtilsService.getAdressen().then(function (adressen) {
                vm.adressenAntragsteller = adressen;
                vm.postleitzahlenAntragsteller = AdresseUtilsService.getUniquePostleitzahlen(adressen);
            });

            BasisAngebotService.getGlobals(vm.angebotModel).then(function (globals) {
                _.merge(vm, globals);
            });

            vm.currentDateMinus120yearsYYYYMMDD = moment().subtract(120, 'years').format(AppConfig.API.dateFormat);

            vm.placeholders = {
                antragstellerGeburtsdatum: {
                    max: [
                        moment().set(momentYearEndObj).diff(vm.maxAntragstellerGeburtsdatum, 'years')
                    ]
                },
                antragstellerTelefonMobil: {
                    telefonnummer: [
                        ''  // Wert wird in isTelefonnummerValide gesetzt
                    ]
                },
                antragstellerTelefonPrivat: {
                    telefonnummer: [
                        ''  // Wert wird in isTelefonnummerValide gesetzt
                    ]
                },
                antragstellerTelefonGeschäftlich: {
                    telefonnummer: [
                        ''  // Wert wird in isTelefonnummerValide gesetzt
                    ]
                }
            };

            vm.postleitzahlDisabled = AppConfig.ANGEBOT.plzAntragstellerEingabeImAngebot;
            vm.geburtsdatumDisabled = AppConfig.ANGEBOT.geburtsdatumAntragstellerEingabeImAngebot;
        }
        function getAdresseErrorObject(errorObjects) {
            return AdresseUtilsService.getAdresseErrorObject(errorObjects);
        }
        function isTelefonnummerValide(kome) {
            var placeholder,
                komeArt = _.get(kome, 'art.wert');

            if (komeArt === 'TELM') {
                placeholder = 'antragstellerTelefonMobil';
            } else if (komeArt === 'TELP') {
                placeholder = 'antragstellerTelefonPrivat';
            } else if (komeArt === 'TELG') {
                placeholder = 'antragstellerTelefonGeschaeftlich';
            } else {
                placeholder = 'antragstellerTelefonMobil';
            }

            return AngebotUtilsService.isTelefonnummerValide(kome).then(function () {
                return $q.resolve();
            }).catch(function (error) {
                _.set(vm.placeholders, placeholder + '.telefonnummer', _.get(error, 'message'));

                return $q.reject();
            });
        }
        function setAdresseAntragsteller(adresse) {
            if (AdresseUtilsService.isAdresseVollstaendig(adresse)) {
                _.merge(_.get(vm.angebotModel.angebot, 'antragsteller'), adresse);
            }
        }

        function onChangeAnrede(anrede) {
            _.set(vm.angebotModel.angebot, 'antragsteller.anrede', anrede);
        }

        function onChangeFirmenname(firmenname) {
            if (!firmenname) {
                _.set(vm.angebotModel.angebot, 'antragsteller.name2', null);
            }
        }
    }
})();
